$('.search-wrapper').click(function(){
    // console.log('here');
    $(this).find('input').toggleClass('hidden');
});

$('.Search__Close').click(function(){
    $('.search-wrapper').find('input').removeClass('hidden');
});

$('.currency-picker__btn').click(function(){
    $('#CurrencyModal').toggleClass('modal--is-active');
});

$('.currency-options__btn').click(function(){
    $('.currency-picker .currency-flag').attr('data-flag', $(this).attr('data-value'));
    $('.currency-picker .currency-picker__label').html($(this).attr('data-value'));
    $('.currency-options__btn.is-active').removeClass('is-active');
    $(this).addClass('is-active');
    $('#CurrencyModal').removeClass('modal--is-active');
});

$('.currency-picker .currency-flag').attr('data-flag', $('.CurrencySelector__Select ').val());
$('.currency-picker .currency-picker__label').html($('.CurrencySelector__Select ').val());
$('.currency-options__btn.is-active').removeClass('is-active');
$('button[data-value=' + $('.CurrencySelector__Select ').val() + ']').addClass('is-active');

$('#CurrencyModal .modal__close').click(function(){
    $('#CurrencyModal').removeClass('modal--is-active');
});

$(document).on('change', '.ColorSwatch__Radio', function(e){
    console.log($('.Size__SelectedValue').html());    
   if($('.Size__SelectedValue').html() == 'Size') {
       e.preventDefault();
       e.stopPropagation();
       $('.Color__SelectedValue').html($(this).val());    
   } else {
        $('#BIS_trigger').css('opacity', 1);
        $('#BIS_trigger').css('position', 'relative');
   }
});

$('.event-section .section-content').css('height', $('.event-section .img-wrapper').height());

$('.event-textarea').val("RSVP");

$('.btn-rsvp').click(function(e){
    e.preventDefault();
    $('.rsvp-modal').addClass('modal--is-active'); 
});

$('.rsvp-modal .modal__close').click(function(){
    $('.rsvp-modal').removeClass('modal--is-active');
});

var _className = '';
if($(window).width() > 768){
  _className = 'mobile__hide';
}
else {
  _className = 'desktop__hide';
}

$('.is-visible .image-container.'+_className).lightSlider({
    gallery:false,
    item: 1,
    slideMargin: 0,
    speed:500,
    auto:false,
    loop:true,
    pager: true,
    slideMargin: 1,
    enableDrag: true,
    prevHtml: '<svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg>',
    nextHtml: '<svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>',
    onSliderLoad: function() {
      $('.is-visible .image-container.'+_className).removeClass('image-container');
    },
    onBeforeSlide: function(a, b) {
      change_behind_img(b);
	}
});

$(document).on('click', '.events-title li', function(e){
    const target = $(this);
    const eventContent = $('.events-item-content-' + target.data('id'));
    target.parent().find('.is-active').removeClass('is-active');
    target.addClass('is-active');
    $('.events-item-content').removeClass('is-visible');
    eventContent.addClass('is-visible');
    eventContent.find('.image-container.'+_className).lightSlider({
        gallery:false,
        item: 1,
        slideMargin: 0,
        speed:500,
        auto:false,
        loop:true,
        pager: true,
        slideMargin: 1,
        enableDrag: true,
        prevHtml: '<svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg>',
        nextHtml: '<svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>',
        onSliderLoad: function() {
          $('.is-visible .image-container.'+_className).removeClass('image-container');
        },
        onBeforeSlide: function(a, b) {
          change_behind_img(b);
        } 
    });
});


function change_behind_img(idx) {
  var prev_index = idx % 2;
  var _index = (prev_index + 1) % 2;
  var _content = $(".events-item-content.is-visible");
  _content.find('.behind-img').find('.behind-img-'+prev_index).fadeOut(200, function(){
  	$(this).removeClass('is-visible');
    _content.find('.behind-img').find('.behind-img-'+_index).fadeIn(200).addClass('is-visible');
  })
  
}


if( $(window).width() <= 768) {
    $('.AnnouncementBar__Content').lightSlider({
        gallery:false,
        item: 1,
        slideMargin: 0,
        speed:500,
        auto:true,
        loop:true,
        pager: false,
        controls: false,
        slideMargin: 1,
        enableDrag: true,
        onSliderLoad: function() {
        }  
    });

    

}

$(document).on('click', '.Footer__Block--links .Footer__Title' , function(e){
    $(this).next().slideToggle();
});

$(document).on('click', '.btn-wishlist', function(){
    const target = $(this);
    const img = target.find('img');
    if(target.hasClass('wishlist-added')) {
        $('.wk-remove-product').trigger('click');
        target.removeClass('wishlist-added');
        img.attr('src', 'https://cdn.shopify.com/s/files/1/0319/8704/0389/t/7/assets/wishlist-blank.svg?v=1583260639');
    } else {
        $('.wk-add-product').trigger('click');
        target.addClass('wishlist-added');
        img.attr('src', 'https://cdn.shopify.com/s/files/1/0319/8704/0389/t/7/assets/wishlist-fill.svg?v=1583260641');
    }
});
$(document).on("click", ".Footer__Title.Heading", function(){
    $(this).toggleClass("open");
})
$(document).on("click", ".filter_by-open", function(){
    if($(window).width() < 768) {
        $("html").toggleClass("no-scroll");
        $(".PageOverlay").toggleClass("is-visible");
        $("#collection-filter-drawer").attr("aria-hidden", "false");
    }
})
$(document).on("click", ".Drawer__Close.Icon-Wrapper--clickable", function(){
    $("#collection-filter-drawer").attr("aria-hidden", "true");
    $(".PageOverlay").toggleClass("is-visible");
    $("html").toggleClass("no-scroll");
})
$(document).on("click", ".PageOverlay", function(){
    $("#collection-filter-drawer").attr("aria-hidden", "true");
    $(this).removeClass("is-visible");
    $("html").removeClass("no-scroll");
})
$(document).on("click", ".SidebarMenu__CurrencySelector", function(){
    $("#sidebar-menu").attr("aria-hidden", "true");
    $(".PageOverlay").toggleClass("is-visible");
})